__turbopack_context__.v({
  "avatar": "designer-module__VcMWHq__avatar",
  "banner": "designer-module__VcMWHq__banner",
  "bannerBackground": "designer-module__VcMWHq__bannerBackground",
  "card": "designer-module__VcMWHq__card",
  "content": "designer-module__VcMWHq__content",
  "empty": "designer-module__VcMWHq__empty",
  "followWrap": "designer-module__VcMWHq__followWrap",
  "message": "designer-module__VcMWHq__message",
  "metaRow": "designer-module__VcMWHq__metaRow",
  "page": "designer-module__VcMWHq__page",
  "pager": "designer-module__VcMWHq__pager",
  "products": "designer-module__VcMWHq__products",
  "sidebar": "designer-module__VcMWHq__sidebar",
  "sortActive": "designer-module__VcMWHq__sortActive",
  "tagActive": "designer-module__VcMWHq__tagActive",
  "tags": "designer-module__VcMWHq__tags",
  "topLine": "designer-module__VcMWHq__topLine",
  "wrap": "designer-module__VcMWHq__wrap",
});
